import { Routes } from "@angular/router";
import { noAuthGuard } from "./core/guards/no-auth.guard";
import { authGuard } from "./core/guards/auth.guard";
import { AUTH_ROUTES } from "lib-klab-auth-ui";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  ...AUTH_ROUTES.map((r) => ({
    ...r,
    canActivate: [noAuthGuard],
  })),
  {
    // URL temporal del onboarding
    path: "collaborator-portal",
    canActivate: [authGuard],
    loadComponent: () =>
      import("./modules/home/components/home-shell/home-shell.component").then(
        (m) => m.HomeShellComponent,
      ),
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./modules/collaborator-portal/pages/collaborator-portal-page/collaborator-portal-page.component").then(
            (m) => m.CollaboratorPortalPageComponent,
          ),
      },
    ],
  },
  {
    path: "app",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./modules/home/home.routes").then((m) => m.HOME_ROUTES),
  },
  {
    path: "**",
    redirectTo: "login",
  },
];
